<template>
  <div id="company">
    <img id="url"/>
    <loader v-if="this.loading" ref="Loader"></loader>
    <div v-if="this.loading === false" class="grid-container-company">
      <div class="company-title-menu-wrapper">
        <div class="company-title-wrapper">
          <font-awesome-icon
              v-if="this.company.state.urgent === 1"
              class="state-icon"
              icon="exclamation"
          />
          <font-awesome-icon
              v-if="this.company.state.favorite === 1"
              class="state-icon"
              icon="heart"
          />
          <font-awesome-icon
              v-if="this.company.state.exact === 1"
              class="state-icon"
              icon="briefcase"
          />
          <div class="company-name">{{ company.name }}</div>
          <div class="link-wrapper">
            <font-awesome-icon
                icon="link"
                class="website-link"
                v-on:click="navigateToWebsiteCompany"
            />
          </div>
          <router-link
              :to="{ path: '/pdf' }"
              class="state-icon-companies"
          >
            <div class="pdf-wrapper">
              <font-awesome-icon icon="file-pdf" class="website-link" v-on:click="cacheGraphForPdf"
              />
            </div>
          </router-link>

        </div>
      </div>
      <div class="company-info-graph-container">
        <div class="company-container-info box">
          <div class="company-title">
            <div class="company-menu-wrapper">
              <company-menu
                  class="company-menu"
                  :company="this.company"
              ></company-menu>
            </div>
          </div>
          <div class="company-name-infobox">{{ company.name }}</div>
          <div class="company-branche">{{ company.branche }}</div>
          <div class="company-info">
            <span>{{ this.address }}</span>
            <span>{{ this.postalCode }}</span>
            <span>{{ this.country }}</span>
            <span>{{ this.companyDetails.international_phone_number }}</span>
          </div>
          <div v-if="this.company.contact.address !== null">
            <GoogleMap :location="this.company.name"></GoogleMap>
          </div>
        </div>
        <div class="company-graph-container">
          <YearOverviewGraph :graph="this.graph"></YearOverviewGraph>
        </div>
      </div>
      <div class="company-reviews">
        <Reviews :reviews="this.company.posts"></Reviews>
      </div>
    </div>
  </div>
</template>

<script>
import YearOverviewGraph from "@/components/YearOverviewGraph.vue";
import Reviews from "@/components/Reviews.vue";
import GoogleMap from "@/components/GoogleMap";
import Loader from "@/components/Loader.vue";
import CompanyMenu from "@/components/CompanyMenu.vue";
import {central_api_domain} from "@/constants/endpoints";

export default {
  name: "Company",
  data() {
    return {
      name: "Company",
      company: {},
      graph: {},
      loading: true,
      companyDetails: {},
      address: "",
      postalCode: "",
      country: "",
      centralAPIDomain: central_api_domain,
      graphUrl: ""
    };
  },

  components: {
    GoogleMap,
    YearOverviewGraph,
    Reviews,
    Loader,
    CompanyMenu,
  },
  methods: {
    getCompany() {
      fetch(this.centralAPIDomain + "organisations/" + this.$route.params.id)
          .then((res) => res.json())
          .then((result) => {
            this.loading = false;
            this.company = result.company;
            this.graph = result.graph;
          });
    },
    setCompanyDetails(details) {
      this.companyDetails = details;
      let locationDetails = details.formatted_address.split(",");
      this.address = locationDetails[0];
      this.postalCode = locationDetails[1];
      this.country = locationDetails[2];
    },
    navigateToWebsiteCompany() {
      window.open(this.companyDetails.website);
    },
    getName() {
      return this.name;
    },
    cacheGraphForPdf() {
      let chart = document.getElementById("bar-chart");
      if (chart !== null) {
        this.$parent.setCompanyId(this.company.id);

        this.$parent.setPdfCompany(this.company);
      }
    }
  },
  created() {
    this.$parent.setCurrentPage(this);
    this.getCompany();
  },
  mounted() {
    this.cacheGraphForPdf();
  }
};
</script>
